<template>
  <div>
    <q-dialog 
      :visible="isVisible"
      title="更换支付方式"
      width="600px"
      :innerScroll="false"
      :offsetHeight="170"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <el-form :model="formData" ref="ruleForm" size="small" label-width="100px">
        <el-form-item label="支付方式" prop="payWay">
          <el-radio-group v-model="formData.payWay">
            <el-radio :label="1">微信支付</el-radio>
            <el-radio :label="0">银联支付</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form> 
    </q-dialog>
  </div>
</template>

<script>
export default {
  props: {
    isShowChangePayWayDialog: {
      type: Boolean,
      default: false
    },
    changePayWayParams: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.isShowChangePayWayDialog
      },
      set(newVal) {
        this.$emit('update:isShowChangePayWayDialog',newVal)
      }
    },
  },
  watch: {
    isShowChangePayWayDialog(newVal,oldVal) {
      if (newVal) {
        this.formData.payWay = this.changePayWayParams.payWay
      }
    }
  },
  data() {
    return {
      formData: {
        payWay: "",
      },
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false
    },
    onConfirm() {
      const { payWay } = this.formData
      this.$api.dataReport.modifyCustomerPayWay({
        ...this.changePayWayParams,
        payWay
      }).then(res => {
          if (res.success) {
            this.$message.success("更换成功");
            this.onCancel()
            this.$emit('changePayWaySuccess')
          }
        })
    }
  }
}
</script>
<style lang="stylus" scoped>
</style>
